import { Form, type FormInstance, Input, Select } from 'antd';
import { isEmpty } from 'lodash';
import type React from 'react';
import { FINAL_RATING_OPTIONS } from '../../../../../common/constants';
import type { ReligiousTransparencyAnalysesData } from '../ReligiousTransparencyAnalysis';

const { TextArea } = Input;

const FinalReviewForm: React.FC<{
  form: FormInstance;
  setIsSubmitBtnDisabled: React.Dispatch<React.SetStateAction<boolean>>;
  selectReligiousTransparencyData:
    | ReligiousTransparencyAnalysesData
    | undefined;
}> = ({ form, setIsSubmitBtnDisabled, selectReligiousTransparencyData }) => {
  const feedbackData = selectReligiousTransparencyData?.subSection?.feedback;
  return (
    <Form
      layout="vertical"
      form={form}
      className="signal-detection-form-grid"
      initialValues={{}}
      onValuesChange={() => setIsSubmitBtnDisabled(false)}
    >
      <div className="signal-detection-form-item signal-detection-form-item">
        <Form.Item
          label="Overall Bias Score"
          name="religiousOverallBiasScore"
          className={
            feedbackData?.religiousOverallBiasScore !== undefined &&
            selectReligiousTransparencyData?.overallBiasScore !== undefined
              ? 'signal-detection-form-item--with-below-text'
              : 'signal-detection-form-item'
          }
        >
          <Select
            size="middle"
            options={FINAL_RATING_OPTIONS}
            placeholder="Select final rating"
          />
        </Form.Item>
        {feedbackData?.religiousOverallBiasScore != null &&
          selectReligiousTransparencyData?.overallBiasScore != null && (
            <div className="signal-detection-below-text">
              <span className="font-w-600">Originally:</span>{' '}
              <span>{selectReligiousTransparencyData?.overallBiasScore}</span>
            </div>
          )}
      </div>
      <div className="signal-detection-form-item signal-detection-form-item">
        <Form.Item
          label="Rating Reason"
          name="religiousReasonNote"
          className={
            !!feedbackData?.religiousReasonNote &&
            !isEmpty(selectReligiousTransparencyData?.reasonNote)
              ? 'signal-detection-form-item--with-below-text'
              : 'signal-detection-form-item'
          }
        >
          <TextArea
            className="reason-textarea"
            placeholder="Enter reason for rating"
            rows={6}
          />
        </Form.Item>
        {!!feedbackData?.religiousReasonNote &&
          !isEmpty(selectReligiousTransparencyData?.reasonNote) && (
            <div className="signal-detection-below-text">
              <span className="font-w-600">Originally:</span>{' '}
              <span>{selectReligiousTransparencyData?.reasonNote}</span>
            </div>
          )}
      </div>
    </Form>
  );
};

export default FinalReviewForm;
